export default {
	insert: {
		id: '아이디를 입력해 주세요.',
		pw: '비밀번호를 입력해 주세요.',
	},

	find: {
		id: '아이디 찾기',
		pw: '비밀번호 찾기',
	},

	filter: {
		filter: '필터',
		all: '전체',
		add: '추가',
		delete: '삭제',
		modify: '수정',
	},
	header: {
		alarm: {
			allRead: '모두 읽음',
			noAlarm: '새로운 알림이 없습니다.',
			/** {name}: 호출자 ID/이름 */
			leftComment: '{name}님이 댓글을 남겼습니다.',
			leftSignatureRequest: '{name}님이 서명 요청을 했습니다.',
			signatureRequest: '{name}님이 서명 요청을 했습니다.',
			time: '오늘',
			yesterday: '어제',
			/** {n}: 숫자 */
			minutesAgo: '{n}분 전',
			hoursAgo: '{n}시간 전',
			daysAgo: '{n}일 전',
			avatarAlt: '프로필',
			timeAgo: '시간전',
			dayAgo: '일전',
			weekAgo: '주전',
			monthAgo: '월전',
			yearAgo: '년전',
		},
	},

	modal: {
		title: '알림',
		message: '삭제하시겠습니까?',
		serverError: '에러가 발생했습니다. 잠시 후 다시 시도해 주세요.',
		signature: {
			title: '서명',
			upload: '업로드',
			draw: '그리기',
			uploadDescription: '파일을 드래그하거나 파일 선택 버튼을 클릭해 업로드할 파일을 선택해주세요.',
			selectFile: '파일 선택',
			drawDescription: '서명을 여기에 입력해주세요',
			reset: '초기화',
			undo: '실행 취소',
			redo: '실행 다시',
			save: '저장',
			close: '닫기',
			invalidExtension: '허용되지 않은 파일 형식입니다. 이미지 파일만 업로드 가능합니다.',
			multipleFiles: '하나의 파일만 업로드 가능합니다.',
		},
		fileUpload: {
			noFile: '업로드한 파일이 존재하지 않습니다. 다시 시도해 주세요.',
			noExtension: '파일 확장자를 다시한번 확인해주세요.',
			noFileName: '파일 이름이 조회되지 않았습니다. 다시 시도해 주세요.',
			sizeExceeded: '파일 크기가 1MB를 초과하였습니다. 1MB 이하로 업로드 해주세요.',
		},
		save: '저장이 완료되었습니다.',
		signatureCancel: '서명이 취소되었습니다.',
		block: '블록을 선택해 주세요.',
		file: '파일을 선택해 주세요.',
		date: '날짜를 선택해주세요.',
		select: '선택해 주세요.',
		retry: '잠시후 다시 시도해 주세요.',
		projectList: {
			terminate: '프로젝트가 종료되었습니다.',
			delete: '현재 프로젝트 연구노트가 삭제되었습니다.',
			create: '프로젝트가 생성되었습니다',
			createError: '연구노트 생성에 실패했습니다.',
			saveOut: '저장하지 않은 내용이 있습니다,\n저장하지 않은 내용은 사라집니다.\n저장 하시겠습니까?',
			save: '내용을 저장했습니다.',
			title: '프로젝트 제목을 작성해주세요.',
			participant: '참여원을 지정해주세요.',
			approver: '결재원을 지정해주세요.',
			viewer: '뷰어를 지정해주세요.',
			createProject: '프로젝트가 생성되었습니다.',
			update: '프로젝트 수정이 완료되었습니다.',
			errDuplicate: '프로젝트 연구노트명 중복 오류입니다.',
			errDefault: '프로젝트 생성 중 오류 발생했습니다. \n 다시 시도해주세요.',
			errNote: '노트 생성 중 오류 발생했습니다. \n 다시 시도해주세요.',
			msgTerminate: '정말로 종료하시겠습니까?',
			errNoteDelete: '노트 참여자는 프로젝트 참여자에서 제외할 수 없습니다',
			errProjectUpdate: '프로젝트 수정 중 오류 발생했습니다. \n 다시 시도해주세요.',
			errFileOver: '파일 업로드는 100개까지만 가능합니다.',
			errFileOverSize: '파일 업로드는 한번에 10GB까지만 가능합니다.',
		},

		templateList: {
			create: '템플릿 생성이 완료되었습니다.',
			createError: '노트 생성 중 오류가 발생했습니다.\n 다시 시도해주세요.',
			saveOut: '저장하지 않은 변경사항이 있습니다.\n저장하지 않은 변경사항은 사라집니다.\n저장하시겠습니까?',
			save: '내용이 저장되었습니다.',
			delete: '템플릿을 삭제하시겠습니까?',
			title: '템플릿 명을 작성해주세요',
			participant: '참여자를 지정해주세요.',
			approver: '승인자를 지정해주세요.',
			viewer: '조회자를 지정해주세요.',
			update: '템플릿 수정이 완료되었습니다.',
			errDuplicate: '템플릿명 중복 오류입니다.',
			errDefault: '템플릿 생성 중 오류가 발생했습니다.\n 다시 시도해주세요.',
			templateLeaderRequired: '템플릿 리더를 선택해주세요.',
			msgTerminate: '정말로 종료하시겠습니까?',
		},

		uploadImg: '3mb 이하의 이미지만 업로드가 가능합니다.',
		uploadFile: '50mb 이하의 파일만 업로드가 가능합니다.',
		selectFile: 'jpg,jpeg,png,gif 파일만 선택해주세요.',
		selectFileExtension: 'xls,xlsx,pptx,pdf,docx,txt,zip,rar,tar,odt 파일만 선택해주세요.',
		optionList: {
			chart: {
				type: '타입',
				create: '차트 생성',
				labelWarn: '라벨명은 필수입니다.',
				dataWarn: '데이터명은 필수입니다.',
				negativeWarn: '음수로 차트를 생성할 수 없습니다.',
				auto: '자동',
				horizontal: '가로',
				vertical: '세로',
				data: '데이터',
				y: 'y축 라벨명',
				x: 'x축 라벨명',
				color: '색상',
				title: '차트 명',
				warn: '차트의 명을 입력해 주세요.',
				placeholderList: {
					y: 'y축 라벨명을 입력해주세요.',
					x: 'x축 라벨명을 입력해주세요',
					data: '데이터명',
					label: '라벨명',
				},
				noTable: '현재 차트를 만들기 위한 테이블이 존재하지 않습니다.',
				select: '차트를 만들기 위해서 먼저 테이블을 선택해 주세요.',
				multi: '차트를 생성하기 위해서는 단일 범위가 아닌 다중 범위를 지정해야합니다.',
			},
			date: {
				warn: '현재 선택되어 있는 블록에는 날짜를 추가할 수 없습니다.',
			},
		},
		position: '위치를 다시 지정해주세요.',
		range: '현재 선택하신 글자에는 날짜를 추가할 수 없습니다. 범위를 변경해 주세요.',
		dropbox: {
			enterText: '코드와 이름은 한 개 이상 입력해주세요.',
			emptyCode: '번째 코드가 비어있습니다.',
			emptyName: '번째 이름이 비어있습니다.',
			sameCode: '동일한 code는 사용할 수 없습니다.',
		},
		schema: {
			required: 'field, value는 필수입니다.',
			enterTxt: '스키마는 필수 입력입니다.',
			emptyField: '번째 Schema의 field가 비어있습니다.',
			emptyValue: '번째 Schema의 Value가 비어있습니다',
			emptyName: '번째 Schema의 이름이 비어있습니다',
			sameName: '동일한 스키마명은 사용할 수 없습니다.',
		},
		template: {
			create: '템플릿이 생성되었습니다.',
			version: '승인되었습니다.',
			verWarn: '승인할 수 없는 버전입니다.',
			approve: '템플릿 승인',
			approveConfirm: '템플릿을 승인하시겠습니까?',
			approveNeedSave: '저장되지 않은 변경사항이 있습니다. 승인 전에 저장해주세요.',
			tempData: '현재 임시 저장된 데이터가 있습니다.',
			delete: '삭제 후 승인하시겠습니까?',
			deleteAlarm: '템플릿 삭제 중 오류가 발생했습니다.',
			saveErrorMessage: '템플릿 저장 중 오류가 발생했습니다.',
		},
		user: {
			email: '이메일 형식이 아닙니다.',
			phone: '전화번호 형식이 아닙니다.',
			modifyInfo: '정보가 수정되었습니다.',
			position: '직급을 입력해주세요.',
		},
		myPage: {
			name: '이름',
			email: '이메일',
			phone: '연락처',
			department: '부서',
			placeholder: {
				name: '이름을 입력해주세요.',
				phone: '연락처를 입력해주세요.',
				email: '이메일을 입력해주세요.',
			},
			required: '이름을 입력해주세요.',
		},
		session: {
			autoLogout: (minute: number | null | undefined) => `${!minute ? '1분' : minute + '초'} 후 자동로그아웃됩니다.로그인 유지시간 연장을 원하시면 연장버튼을 눌러주세요`,
			autoLogoutTerminate: '로그아웃 되었습니다. 다시 로그인해주세요.',
			terminate: '세션이 종료되었습니다.',
		},
		searchResult: '검색 결과가 없습니다.',
		error: {
			title: '오류',
			template: '템플릿 오류',
			project: '프로젝트 오류',
			department: '부서 오류',
			minimumLength: '최소 2글자 이상 입력해주세요.',
			searchError: '검색 중 오류가 발생했습니다.',
			email: '이메일 형식이 잘못되었습니다.',
			participant: '참여원 목록 조회 중 오류가 발생했습니다.',
			list: '목록 조회 중 오류가 발생했습니다.',
			user: '사용자 조회 중 오류가 발생했습니다.',
			departmentSearch: '부서 조회 중 오류가 발생했습니다.',
			departmentUpdate: '부서 정보 업데이트 중 오류가 발생했습니다.',
			priority: '우선순위 조회 중 오류가 발생했습니다.',
			schema: '스키마 조회 중 오류가 발생했습니다.',
			schemaCreate: '스키마 생성 중 오류가 발생했습니다.',
			schemaSave: '스키마 저장 중 오류가 발생했습니다.',
			schemaListType: '스키마 타입명은 필수입니다.',
			dropbox: '드롭박스 조회 중 오류가 발생했습니다.',
			signature: '서명 조회 중 오류가 발생했습니다.',
			signatureUpload: '서명 업로드 중 오류가 발생했습니다.',
			signatureCancel: '서명 취소 중 오류가 발생했습니다.',
			signatureComplete: '서명 완료 후 목록 새로고침에 실패했습니다.',
			noSignature: '서명이 없습니다. 서명을 추가해 주세요.',
			noteSave: '노트 저장 중 오류가 발생했습니다.',
			logout: '로그아웃에 실패했습니다. 다시 시도해 주세요.',
			projectCloseAlarm: '프로젝트의 모든 노트가 종료되어야 프로젝트를 종료할 수 있습니다.',
			projectOpenAlarm: '현재 프로젝트는 진행 중입니다. 재개는 종료 상태에서만 가능합니다.',
			projectCloseServerError: '종료 과정에서 에러가 발생했습니다.',
			projectOpenServerError: '재개 과정에서 에러가 발생했습니다.',
			searchType: '검색 타입을 선택해 주세요.',
			userUpdate: '사용자 권한 저장 중 오류가 발생했습니다.',
			licenseUpdate: '라이센스 업데이트 중 오류가 발생했습니다.',
			emptyTitle: '제목은 필수값입니다.',
			duplicateTitle: '제목이 중복됩니다.',
			htmlTag: 'HTML 태그를 포함할 수 없습니다.',
			reviewFind: '리뷰 찾기 중 오류가 발생했습니다.',
			projectLeaderFind: '프로젝트 리더 정보 찾기 중 오류가 발생했습니다.',
			note: '노트 조회 중 오류가 발생했습니다.',
			noteUid: '노트 UID가 없습니다.',
			userInfo: '사용자 정보가 없습니다.',
			dateRange: '시작일을 종료일보다 이전으로 설정해주세요.',
			downloadError: '다운로드 중 오류가 발생했습니다.',
			roleNotFound: (roleName: string) => `권한 ${roleName}을 roleList에서 찾을 수 없음`,
			templateDeleteAlarm: '템플릿 삭제 중 오류가 발생했습니다.',
			templateApprove: '템플릿 승인 중 오류가 발생했습니다.',
			templateListRetrieve: '목록을 불러오는데 실패하였습니다.',
			blockTypeFile: '파일은 텍스트 블록에서만 추가할 수 있습니다.',
			blockTypeImage: '이미지는 텍스트 블록에서만 추가할 수 있습니다.',
			blockTypeTable: '테이블은 텍스트 블록에서만 추가할 수 있습니다.',
			blockTypeCalendar: '날짜는 텍스트 블록에서만 추가할 수 있습니다.',
			blockTypeChart: '차트는 테이블 블록에서만 추가할 수 있습니다.',
			latexEmpty: '빈 값은 저장할 수 없습니다.',
		},
		preview: '미리보기',
		success: {
			userUpdate: '사용자 권한 저장이 완료되었습니다.',
			licenseUpdate: '라이센스 업데이트가 완료되었습니다.',
			signatureRequest: '서명 요청이 완료되었습니다.',
			downloadSuccess: '다운로드가 완료되었습니다.',
		},
		noChange: '변경사항이 없습니다.',
		licenseRevoke: '라이센스 해제 하시겠습니까?',
	},

	menu: {
		dashboard: '대시보드',
		project: '프로젝트',
		template: '템플릿',
		schema: '스키마',
		dropbox: '드롭박스',
		note: '노트',
		license: '라이센스',
	},

	sign: {
		in: '로그인',
		up: '회원가입',
		find: {
			id: '아이디 찾기',
			pw: '비밀번호 찾기',
		},
		id: '아이디(이메일)',
		pw: '비밀번호',
		rePw: '비밀번호 확인',
		save: '아이디 저장',
		out: '로그아웃',
		hide: '비밀번호 숨기기',
		show: '비밀번호 보기',
		ing: '로그인 중...',
		checkList: {
			input: '아이디와 비밀번호를 입력해주세요',
			retry: '로그인을 다시 시도해주세요.',
			email: '가입한 이메일을 입력해 주세요.',
		},
		err: {
			employee: '사원 조회 오류입니다. 다시 시도해 주세요.',
			token: '토큰 발급 오류입니다. 다시 시도해 주세요.',
			login_fall: '로그인에 실패했습니다. 아이디와 비밀번호를 확인해 주세요.',
			server_failure: '서버 문제로 로그인에 실패하셨습니다.',
		},
		service: {
			terms: '서비스 이용약관',
			privacy: '개인정보 처리방침',
		},
	},

	user: {
		id: '유저 아이디',
	},

	note: {
		closed: { success: '노트가 종료되었습니다.' },
		signature: { success: '서명이 완료되었습니다.', revoke: '서명이 해제되었습니다.', error: '서명 해제에 실패했습니다.' },
		create: { success: '노트가 생성되었습니다.', existstitle: { failure: '노트명이 이미 존재합니다.' } },
		update: { success: '노트가 수정되었습니다.', notinprogress: { failure: '서명 진행 노트이므로 수정이 불가합니다.' } },
		save: { success: '노트가 저장되었습니다.' },
		retrieve: { notexists: { failure: '존재하지 않는 노트입니다.' } },
		allComplete: '전체 서명이 완료되었습니다.',
	},

	designation: '님',

	dashboard: {
		info: '안녕하세요.',
		project: '프로젝트',
		joinProject: '진행 중인 프로젝트',
		template: '템플릿',
		schema: '스키마',
		dropbox: '드롭박스',
		endableProject: '종료 가능 프로젝트',
		closedProject: '종료된 프로젝트',
		item: '건',
		asset: 'Asset',
	},

	table: {
		no: '번호',
		priority: '우선순위',
		title: '제목',
		dropboxTitle: '제목',
		userNm: '이름',
		userId: '아이디',
		code: '코드',
		email: '이메일',
		phone: '연락처',
		poster: '등록자',
		updatedUserId: '수정자',
		createDt: '등록날짜',
		updateDt: '수정일',
		loginDt: '로그인',
		version: '버전',
		more: '더보기',
		status: '상태',
		description: '설명',
		statusCodeI: '진행',
		statusCodeC: '완료',
		statusCodeY: '사용',
		statusCodeN: '미사용',
		actionType: '동작',
		none: '결과없음',
		content: '현재 데이터가 등록되지 않았습니다.',
		signatureList: '서명목록',
		endDay: '마감일',
		required: '필수',
		uniqueValue: '고유값',
		name: '명칭',
		basic: '기본값',
		use: '사용',
		unUse: '미사용',
		type: '타입',
		thumbnail: '썸네일',
		create: '테이블 생성',
		createError: '테이블 생성 시 최소 1행/열을 지정해야 합니다.',
		createMaxError: '테이블 최초 생성시 30행/열까지 생성할 수 있습니다.',
		addMaxError: '테이블 추가시 최대 100행/열까지 추가할 수 있습니다.',
		department: '부서',
		userCreateDt: '가입 일자',
		revokeDt: '해제날짜',
		renewDt: '갱신날짜',
		expireDt: '만료날짜',
		schemaCellSizeError: '셀의 크기가 추가하려는 스키마의 크기보다 작습니다.\n셀을 늘려서 스키마를 추가해 주세요.',
		schemaDeleteConfirm: '스키마가 포함된 행이 있습니다.\n계속 진행하시면 스키마 행도 같이 지워집니다.\n계속 진행하시겠습니까?',
	},

	search: {
		select: '선택',
		placeholder: '검색어를 입력해 주세요.',
		search: '조회',
		total: '총',
		new: '신규 생성',
		type: '타입 선택',
		year: '연',
		month: '월',
		day: '일',
		startDate: '시작일',
		endDate: '종료일',
		createDate: '등록순',
		modifyDate: '수정순',
		desc: '내림차순',
		asc: '오름차순',
		clear: '전체 삭제',
		close: '닫기',
		pageSizeList: {
			10: '10건',
			20: '20건',
			50: '50건',
			100: '100건',
		},
		typeList: {
			unknownUser: '이름 없음',
			title: '제목',
			userId: '등록자',
			description: '설명',
			type: '타입명',
			status: '상태',
			name: '이름',
			id: '아이디',
			role: '권한',
			employee: '사원 번호',
			email: '이메일',
			phone: '연락처',
			department: '부서',
			executives: '임직원명',
			noteName: '연구 노트명',
		},
		placeholderList: {
			department: '부서명을 입력해 주세요',
			participate: '참여 원구원을 입력해 주세요',
			date: '날짜를 입력해주세요',
			type: '타입을 선택해주세요.',
			version: '버전을 선택해주세요.',
			label: '명칭을 입력해주세요.',
			unique: '고유값을 입력해주세요.',
			basic: '기본값을 입력해주세요.',
			selectBasic: '기본값을 선택해주세요.',
			description: '설명을 입력해주세요.',
			select: '부서명 또는 임직원명을 선택해 주세요.',
		},
	},

	file: {
		attachments: '첨부파일',
		item: '개',
	},

	button: {
		cancel: '취소',
		create: '생성',
		back: '뒤로가기',
		modify: '수정',
		termination: '프로젝트 종료',
		signature: '서명하기 ',
		save: '저장',
		approval: '승인',
		delete: '삭제',
		allDelete: '전체 삭제',
		history: '내역',
		audit: '감사 추적',
		close: '닫기',
		confirm: '확인',
		apply: '적용',
		unsign: '해제',
		end: '종료',
		logout: '로그아웃',
		add: {
			schema: '스키마 추가',
			text: '추가',
			template: '템플릿 추가',
		},
		csv: 'CSV 파일 업로드',
		sync: '동기화',
		thumbnail: '썸네일 변경',
		checkin: 'Check-in',
		use: '사용',
		ok: '확인',
		refresh: '새로고침',
		closeAll: '전체 닫기',
		revoke: '해제',
		assign: '배정',
		renew: '연장',
	},

	sort: {
		desc: '내림차순',
		asc: '오름차순',
		createAt: '등록일순',
	},

	project: {
		modal: {
			create: '프로젝트 생성',
			modify: '프로젝트 수정',
			title: '프로젝트명',
			description: '설명',
			setParticipant: '프로젝트 참여원 설정',
			priority: '중요도',
			projectLeader: '프로젝트 리더',
			placeholder: {
				title: '프로젝트명을 입력해 주세요.',
				description: '프로젝트 설명을 입력해 주세요.',
				projectLeader: '프로젝트 리더를 선택해 주세요.',
				priority: '중요도를 선택해 주세요.',
			},
			departmentName: '부서명',
			err: {
				name: '프로젝트 제목을 입력해 주세요.',
				duplicated: '프로젝트 제목이 이미 사용 중입니다.',
			},
		},

		name: '프로젝트명',
		description: '설명',
		department: '부서',
		participate: '참여연구원',
		setting: '설정',
		select: '프로젝트를 선택해주세요.',
		placeholder: {
			title: '프로젝트명을 입력하세요.',
			description: '프로젝트 설명을 입력하세요.',
		},
		templateAdd: '템플릿 추가',
		err: {
			name: '프로젝트 제목을 입력해 주세요.',
		},

		note: {
			create: '노트 생성',
			existstitle: { failure: '노트 제목이 이미 존재합니다.' },
			name: '노트명',
			template: '템플릿',
			edit: '노트 수정',
			placeholder: {
				name: '노트 제목을 입력해 주세요.',
				description: '노트 설명을 입력해 주세요.',
			},
			err: {
				name: '노트 제목을 입력하세요.',
			},
			audit: {
				update: {
					notinprogress: { failure: '진행중이 아닌 노트는 수정할 수 없습니다.' },
				},
				create: {
					notinprogress: { failure: '노트 생성에 실패했습니다.' },
				},
			},
			status: {
				progress: '진행중',
				reviewing: '검토중',
				pending: '보류',
				closed: '종료',
				new: '신규',
			},
			sideMenu: {
				auditTrail: 'Audit Trail',
				setting: '프로젝트 설정',
				signNote: '노트 서명',
				endProject: '프로젝트 종료',
				confirmEndProject: '종료된 프로젝트는 수정이 불가능 합니다.',
				noteSetting: '노트 설정',
				noteCreate: '노트 추가',
				reopenProject: '프로젝트 재개',
				confirmReopenProject: '종료 상태를 해제하고 수정이 가능 합니다.',
			},
			signature: {
				title: '서명',
				approve: '승인',
				etc: '비고',
				etcPlaceholder: '비고를 입력하세요.',
				sign: '결재',
				load: '서명불러오기',
				request: '서명요청하기',
				requestAll: '전체서명요청',
				unsign: '서명해제',
				confirmSubmit: '서명을 하시겠습니까?',
				confirmAccuracy: '본인은 해당 기록이 정확함을 확인하고 서명합니다.',
				confirmReviewContent: '본인은 해당 버전의 전자연구노트 내용을 검토하였으며, 기록의 누락이나 오류가 없음을 확인하였습니다.',
				confirmAckRequired: '위 항목을 모두 확인한 뒤 확인 버튼을 눌러 주세요.',
				imageUnavailable: '서명 이미지 경로를 불러올 수 없습니다.',
				noRevisionForSign: '노트가 수정된 이력이 없어 서명이 불가합니다.',
			},
		},

		empty: {
			add: '노트 생성 버튼을 클릭하여 노트를 생성해 주세요.',
			finish: '완료된 프로젝트입니다.',
			select: '노트를 선택해 주세요.',
		},

		table: {
			name: '테이블',
			create: '생성',
			max: '최대',
			err: {
				create: '1개 ~ 30개까지 생성 가능합니다.',
			},
			alarmList: {
				create: '테이블에 테이블을 생성하실 수 없습니다.',
				max: '테이블은 최대 30*30 입니다.',
				lastLow: '마지막 행은 삭제할 수 없습니다.',
				lastCol: '마지막 열은 삭제할 수 없습니다.',
				dropbox: '생성된 드롭박스 삭제 후 생성할 수 있습니다.',
				boxCreate: '이 셀은 드롭박스를 생성할 수 없습니다.',
				select: '테이블이 선택되지 않았습니다.\n 다시 시도해주세요.',
			},
		},
		signature: {
			complete: '서명이 완료된 상태입니다.\n수정이 불가합니다.\n수정이 필요하시면 프로젝트 리더에게 서명 해제 요청을 하세요',
			modify: '님이 수정 중입니다.',
			warn: '리뷰어로 서명된 인원이 없습니다.\n노트를 종료하시려면 한명 이상이 리뷰어로 서명하셔야 합니다.\n서명을 해제하여 리뷰어로 서명하시거나\n신규 인원을 추가하여 리뷰어로 서명해 주세요.',
		},
		terminate: '현재 종료된 프로젝트 입니다.',
		admin: '노트를 생성할 권한이 없습니다.',
		create: {
			success: '프로젝트 생성했습니다.',
			existstitle: { failure: '프로젝트명이 이미 존재합니다.' },
		},
		closed: {
			success: '프로젝트가 종료되었습니다.',
			server: { failure: '프로젝트 종료 중 오류가 발생했습니다.' },
			state: { failure: '종료할 수 없는 상태입니다.' },
		},
		opened: {
			success: '프로젝트가 진행 상태로 변경되었습니다.',
			state: { failure: '진행 상태로 변경할 수 없는 상태입니다.' },
		},
		closable: { success: '프로젝트 종료가 가능합니다.' },
		save: { server: { failure: '프로젝트 저장 중 오류가 발생했습니다.' } },
		update: {
			success: '프로젝트가 수정되었습니다.',
			server: { failure: '프로젝트 수정 중 오류가 발생했습니다.' },
			noteparticipants: { failure: '노트 참여자는 프로젝트 참여자에서 제외할 수 없습니다.' },
		},
	},

	sideMenu: {
		left: '왼쪽 정렬',
		center: '가운데 정렬',
		right: '오른쪽 정렬',
		cut: '이미지 자르기',
		captionAdd: '캡션 추가',
		captionRemove: '캡션 삭제',
		delete: '삭제',
		modifyChart: '차트 수정',
		review: '댓글',
		modifyReview: '댓글 수정',
		deleteReview: '댓글 삭제',
		blockAdd: '블록 추가',
	},

	context: {
		rowTitle: '제목 행 지정',
		columnTitle: '제목 열 지정',
		rowTitleRemove: '제목 행 해제',
		columnTitleRemove: '제목 열 해제',
		left: '왼쪽으로 열 추가',
		right: '오른쪽으로 열 추가',
		up: '위쪽으로 행 추가',
		down: '아래쪽으로 행 추가',
		merge: '셀 병합',
		unmerge: '셀 병합 해제',
		removeMerge: '셀 병합 해제',
		deleteRow: '행 삭제',
		deleteCol: '열 삭제',
		dropbox: '드롭박스 생성',
		asset: 'Asset 추가',
		image: '이미지 삽입',
		comment: '댓글 추가',
	},

	options: {
		header: {
			h1: '대제목',
			h2: '중제목',
			h3: '소제목',
			h4: '내용',
			h5: '설명',
			h6: '참조',
		},
		bold: '굵게',
		italic: '기울기',
		strikethrough: '취소선',
		underline: '밑줄',
		superscript: '윗첨자',
		subscript: '아랫첨자',
		color: '글자색상',
		bg: '글자배경',
		fontSize: '글자크기',
		fontChange: '글자체 변경',
		add: {
			table: '테이블 추가',
			image: '이미지 추가',
			calendar: '날짜 추가',
			chart: {
				text: '차트 추가',
				bar: '막대 차트',
				horizontal: '가로 차트',
				line: '선 그래프',
				doughnut: '도넛 차트',
				pie: '원형 차트',
				radar: '레이더 차트',
				scatter: '산점도',
				yTitle: 'y축 라벨명',
				xTitle: 'x축 라벨명',
			},
		},
		upload: '파일 업로드',
		download: 'PDF 다운로드',
	},

	schema: {
		select: '스키마를 선택해 주세요.',
		titleList: {
			title: '제목',
			description: '설명',
			list: '목록',
			type: '타입',
			version: '버전',
			schemaTypeCode: '스키마 타입 코드',
			schemaTypeName: '스키마 타입 명',
		},
		placeholderList: {
			titlePlaceholder: '제목을 입력해 주세요.',
			schemaTypeCode: '스키마 코드를 입력하세요.',
			schemaTypeName: '스키마 타입 명을 입력하세요.',
			description: '스키마 설명을 입력하세요.',
			schemaName: '스키마 명을 입력하세요.',
			field: '필드를 입력하세요.',
			value: '값을 입력하세요.',
			unique: '고유값을 입력하세요.',
			basic: '기본값을 입력하세요.',
			selectBasic: '기본값을 선택하세요.',
		},
		modal: {
			create: '스키마가 생성되었습니다.',
			modify: '스키마가 수정되었습니다.',

			schemaTypeCode: '스키마 코드는 필수입니다.',
			schemaTypeName: '스키마 타입은 필수입니다.',
			schemaTitle: '스키마 제목은 필수입니다.',
			schemaContent: '스키마 내용은 필수입니다.',
			schemaUnique: '고유값은 필수입니다.',
			schemaField: '스키마 필드는 필수입니다.',
			schemaValue: '스키마 값은 필수입니다.',
			schemaFieldAndValue: '스키마 필드와 값을 입력해주세요.',
			schemaName: '스키마 명은 필수입니다.',
			schemaLabelRequired: '명칭은 필수입니다.',
			schemaListRequired: '스키마 목록은 필수입니다.',
			required: '필수값을 입력해주세요.',
			schemaDuplicate: '스키마 제목이 이미 사용 중입니다.',
			schemaDropbox: '드롭박스를 먼저 생성해 주세요.',
			schemaListType: '스키마 타입은 필수입니다.',
			schemaDropboxDefault: '드롭박스 기본값은 필수입니다.',
		},
		radio: {
			use: '사용',
			unused: '미사용',
		},

		error: {
			unique: '고유값은 중복될 수 없습니다.',
			maxLength: '200자 이하로 입력해 주세요.',
			maxCount: '스키마 목록은 최대 50개까지 생성됩니다.',
			blockMaxCount: '필드와 밸류는 최대 30개까지 추가할 수 있습니다.',
			cannotDeleteExisting: '기존 생성된 스키마는 삭제할 수 없습니다.',
		},
		create: {
			success: '스키마가 생성되었습니다.',
			server: { failure: '스키마 생성 중 오류가 발생했습니다.' },
			title: { failure: '스키마 제목은 필수입니다.' },
			uniquevalue: { failure: '고유 값이 중복되었습니다.' },
		},
		retrieve: {
			existstitle: { failure: '스키마 제목이 이미 존재합니다.' },
		},
		save: {
			success: '스키마가 저장되었습니다.',
			server: { failure: '스키마 저장 중 오류가 발생했습니다.' },
			uniquevalue: { failure: '고유 값이 중복되었습니다.' },
		},
	},

	dropbox: {
		defaultPlaceholder: '선택 해 주세요',
		select: '드롭박스를 선택해 주세요.',

		info: {
			status: '사용 여부',
			active: '사용',
			inActive: '미사용',
			version: '버전',
			versionPlaceholder: '버전을 선택해 주세요',
			title: '제목',
			titlePlaceholder: '제목을 입력해 주세요.',
			description: '설명',
			descriptionPlaceholder: '설명을 입력해 주세요.',
			placeHolder: '표시문구',
			placeHolderPlaceholder: '표시문구를 입력해 주세요',
			titleRequired: '제목은 필수입니다.',
			titleDuplicate: '제목이 이미 사용 중입니다.',
			save: '저장',
		},
		item: {
			list: '목록',
			code: '코드',
			value: '값',
			default: '기본값',
			codePlaceholder: '코드를 입력해 주세요.',
			valuePlaceholder: '값을 입력해 주세요.',
			codeWarn: '코드는 필수입니다.',
			valueWarn: '값은 필수입니다.',
			codeRequired: '코드는 필수입니다.',
			valueRequired: '값은 필수입니다.',
			codeDuplicate: '두 개의 코드는 동일한 이름을 가질 수 없습니다.',
			active: '사용',
			inActive: '미사용',
			create: '생성',
			status: '상태',
		},
		right: {
			noSelect: '선택된 값이 없습니다.',
			select: '좌측의 목록을 선택하면 상세 내용을 확인할 수 있습니다.',
			active: '사용',
			inActive: '미사용',
			default: '기본값',
			noDefault: '미선택',
		},
		create: {
			success: '드롭박스가 생성되었습니다.',
			codeduplicate: { failure: '코드가 중복되었습니다.' },
			existscode: { failure: '코드가 이미 존재합니다.' },
			existstitle: { failure: '제목이 이미 존재합니다.' },
			server: { failure: '드롭박스 생성 중 오류가 발생했습니다.' },
		},
		save: {
			success: '드롭박스가 저장되었습니다.',
			codeduplicate: { failure: '코드가 중복되었습니다.' },
			server: { failure: '드롭박스 저장 중 오류가 발생했습니다.' },
		},
		error: {
			maxLength: '200자를 초과할 수 없습니다.',
			defaultRequired: '기본값은 필수입니다.',
		},
	},

	template: {
		modal: {
			create: '템플릿 생성',
			modify: '템플릿 수정',
			title: '템플릿명',
			description: '설명',
			templateLeader: '템플릿 리더',
			templateNameRequired: '템플릿 명을 입력해주세요.',
			placeholder: {
				title: '템플릿명을 입력해주세요.',
				description: '템플릿 설명을 입력해주세요.',
				templateLeader: '템플릿 리더를 선택해주세요.',
			},
		},
		createTemplate: '템플릿 생성',
		templateName: '템플릿명',
		placeholder: {
			title: '템플릿명을 입력하세요',
			description: '템플릿 설명을 입력하세요',
		},
		warn: '템플릿 명은 필수입니다.',
		sideMenu: {
			auditTrail: 'Audit Trail',
			setting: '템플릿 설정',
			approve: '템플릿 승인',
		},
		select: '템플릿을 선택해 주세요.',
		create: {
			success: '템플릿 생성 성공',
			existstitle: { failure: '템플릿명이 이미 존재합니다.' },
			server: { failure: '템플릿 생성 중 오류가 발생했습니다.' },
		},
		approve: {
			success: '템플릿이 승인되었습니다.',
			server: { failure: '템플릿 승인 중 오류가 발생했습니다.' },
		},
		checkin: {
			success: '체크인되었습니다.',
			usebyanotheruser: { failure: '다른 사용자가 사용 중입니다.' },
		},
		checkout: { success: '체크아웃되었습니다.' },
		save: {
			success: '템플릿이 저장되었습니다.',
			server: { failure: '템플릿 저장 중 오류가 발생했습니다.' },
			block: { failure: '블록을 먼저 선택해 주세요.' },
			table: { failure: '테이블 상태가 올바르지 않습니다.' },
			notfoundtemplate: { failure: '템플릿을 찾을 수 없습니다.' },
		},
		status: { change: { failure: '상태 변경에 실패했습니다.' } },
		update: {
			success: '템플릿이 수정되었습니다.',
			server: { failure: '템플릿 수정 중 오류가 발생했습니다.' },
			notfoundtemplate: { failure: '템플릿을 찾을 수 없습니다.' },
		},
	},

	admin: {
		menu: {
			project: '프로젝트',
			template: '템플릿',
			schema: '스키마',
			dropbox: '드랍박스',
		},
		access: '권한',
		id: '아이디',
		name: '이름',
		companyName: '회사명',
		placeholder: {
			userId: '아이디를 입력해주세요.',
			companyName: '회사명을 입력해주세요.',
			departmentName: '부서명을 입력해주세요.',
			createDt: '등록일시를 입력해주세요.',
			loginDt: '마지막 로그인을 입력해주세요.',
		},
		departmentName: '부서명',
		positionName: '직급',
		number: '사번',
		email: '이메일',
		phone: '연락처',
		date: '등록일시',
		loginDt: '마지막 로그인',
		department: '부서',
		employees: '임직원',
		emailFormat: '이메일 형식이 잘못되었습니다.',
		role: {
			Name: '권한',
			roleSet: '권한 설정',
			roleList: '권한 목록',
			roleDepartment: '부서 권한',
			roleAddDelete: '권한 추가 및 삭제',
			employeeRoleGroup: '권한 그룹 임직원',
			createRoleGroup: '권한 그룹 생성',
			deleteRoleGroup: '권한 그룹 삭제',
		},
	},
	license: {
		title: '제품 License 정보',
		licenseName: 'License 명',
		status: '라이센스 상태',
		ver: '버전',
		endDate: '만료',
		maxCapacity: '최대 사용 용량',
		update: '업데이트 날짜',
		count: '라이센스 활성 사용자 수',
	},

	// 감사 actionKey 대응 메시지
	audit: {
		license: {
			assign: { success: '라이선스가 배정되었습니다.', server: { failure: '라이선스 배정 중 오류가 발생했습니다.' } },
			revoke: { success: '라이선스가 해제되었습니다.', server: { failure: '라이선스 해제 중 오류가 발생했습니다.' } },
		},
		department: { updateuser: { success: '사용자 권한 저장이 완료되었습니다.' } },
	},

	pagination: {
		prev: '이전',
		next: '다음',
	},

	notFound: {
		title: '페이지를 찾을 수 없습니다',
		message: '요청하신 페이지를 찾을 수 없습니다',
		home: '홈으로',
	},

	userModal: {
		user: '참여원 지정',
		approver: '결재원 지정',
		viewer: '뷰어 지정',
		license: '라이선스 배정',
	},
	asset: {
		select: '메뉴를 선택하세요.',
	},
	tab: {
		new: '새 탭',
	},

	review: {
		now: '방금전',
		min: '분전',
		hour: '시간전',
		day: '일전',
		week: '주전',
		month: '월전',
		year: '년전',
		modify: '댓글 수정',
		delete: '댓글 삭제',
	},

	auth: {
		login: {
			userid: {
				failure: '로그인 실패',
			},
			success: '로그인 성공',
			failure: '로그인에 실패했습니다.',
			password: { failure: '비밀번호가 일치하지 않습니다.' },
		},
		logout: {
			success: '로그아웃 성공',
			confirm: '로그아웃 하시겠습니까?',
			failure: '로그아웃에 실패했습니다. 다시 시도해 주세요.',
		},
	},

	mypage: {
		retrieve: { success: '내 정보를 조회했습니다.' },
		update: { success: '정보가 수정되었습니다.' },
		upload: {
			drawsignature: { failure: '서명(그리기) 업로드 중 오류가 발생했습니다.' },
			jsonparsing: { failure: 'JSON 파싱 중 오류가 발생했습니다.' },
			notfounddrawsignature: { failure: '그리기 서명을 찾을 수 없습니다.' },
			notfoundsignature: { failure: '서명을 찾을 수 없습니다.' },
			profile: { failure: '프로필 업로드 중 오류가 발생했습니다.' },
			signature: { failure: '서명 업로드 중 오류가 발생했습니다.' },
		},
	},

	department: {
		detail: {
			user: '유저 정보',
			info: '상세 정보',
			role: '권한 목록',
			default: '기본 권한',
		},
		group: {
			info: '그룹 인원',
			select: '부서를 선택해주세요',
			groupName: '그룹명',
			groupLeader: '그룹장',
			groupMember: '그룹 인원',
			groupMemberSelect: '그룹 인원을 선택해주세요',
			name: '이름(ID)',
		},

		modal: {
			updateSuccess: '부서 정보 업데이트에 성공했습니다.',
			updateFailure: '부서 정보 업데이트에 실패했습니다.',
		},
	},

	// 감사(audit) 자연어 메시지 템플릿
	auditText: {
		ipSuffix: ' ip({ip})',
		user: {
			update: {
				success: '{user}님의 정보가 업데이트되었습니다.',
			},
		},
		login: {
			success: '{user} 님이 로그인에 성공했습니다.{ipSuffix}',
			failure: '{user} 님의 로그인에 실패했습니다.{ipSuffix}',
		},
		note: {
			create: '{note} 노트가 생성되었습니다.',
			save: '{note} 노트가 저장되었습니다.',
			update: '{note} 노트가 수정되었습니다.',
			closed: '{note} 노트가 종료되었습니다.',
			signature: {
				success: '{note} 노트 서명이 완료되었습니다.',
				failure: '{note} 노트 서명 처리에 실패했습니다.',
			},
		},
		project: {
			create: '{project} 프로젝트가 생성되었습니다.',
			save: '{project} 프로젝트가 저장되었습니다.',
			update: '{project} 프로젝트가 수정되었습니다.',
			closable: '{project} 프로젝트를 종료할 수 있습니다.',
			closed: '{project} 프로젝트가 종료되었습니다.',
			opened: '{project} 프로젝트가 진행 상태로 변경되었습니다.',
		},
		template: {
			create: '{template} 템플릿이 생성되었습니다.',
			save: '{template} 템플릿이 저장되었습니다.',
			update: '{template} 템플릿이 수정되었습니다.',
			approve: '{template} 템플릿이 승인되었습니다.',
			checkin: '{template} 템플릿이 체크인되었습니다.',
			checkout: '{template} 템플릿이 체크아웃되었습니다.',
		},
		dropbox: {
			create: '{dropbox} 드롭박스가 생성되었습니다.',
			save: '{dropbox} 드롭박스가 저장되었습니다.',
		},
		schema: {
			create: '{schema} 스키마가 생성되었습니다.',
			save: '{schema} 스키마가 저장되었습니다.',
		},
		license: {
			assign: '{userId}이 라이선스 {assignedLicenseName}를 {assignedUsers}에게 배정했습니다.',
			revoke: '{userId}이 라이선스 {revokedLicenseName}를 {revokedUsers}에게서 해제했습니다.',
		},
		department: {
			updateuser: '사용자 권한이 저장되었습니다.',
		},
	},

	ai: {
		title: 'AI 어시스턴트',
		model: '모델',
		apiKey: 'API 키',
		apiKeyPlaceholder: 'Gemini API 키를 입력하세요',
		inputPlaceholder: '메시지를 입력하세요... (Enter 전송)',
		send: '전송',
		clear: '초기화',
		empty: 'AI 어시스턴트와 대화를 시작해보세요.',
		ollamaNoModels: '모델을 찾을 수 없습니다',
		includeEditor: '에디터 내용 포함',
		analyze: '에디터 분석',
		analyzePrompt: '위 내용을 요약하고 분석해주세요.',
		copy: '복사',
		copied: '복사됨!',
	},
}
